import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import omit from 'lodash/omit';
import { styledButton } from './styles.js';
import { jsx } from '@emotion/react';
import mergeDefaultProps from '../../../utils/merge-default-props.js';
import filterAriaAttributes from '../../../utils/filter-aria-attributes.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var propsToOmit = ['onClick'];
var getIsEnterOrSpace = function getIsEnterOrSpace(e) {
  return e.key === ' ' || e.key === 'Enter';
};
var defaultProps = {
  as: 'button',
  disabled: false,
  type: 'button'
};
var AccessibleButtonInternal = function AccessibleButtonInternal(props, ref) {
  var propsInternal = mergeDefaultProps(props, defaultProps);
  var as = propsInternal.as,
      buttonAttributes = propsInternal.buttonAttributes,
      children = propsInternal.children,
      className = propsInternal.className,
      dataTestId = propsInternal.dataTestId,
      disabled = propsInternal.disabled,
      isDisabled = propsInternal.isDisabled,
      isToggleButton = propsInternal.isToggleButton,
      isToggled = propsInternal.isToggled,
      label = propsInternal.label,
      onClick = propsInternal.onClick,
      type = propsInternal.type;
  var isButtonDisabled = isDisabled || disabled;
  var handleClick = React.useCallback(function (event) {
    if (isButtonDisabled) {
      event.preventDefault();
      return false;
    } else if (onClick) {
      return onClick(event);
    }
  }, [onClick, isButtonDisabled]);
  var isButton = !as || as === 'button';
  var buttonProps = {};
  if (isButton) {
    buttonProps = {
      type: type
    };
  } else if (!isButtonDisabled) {
    buttonProps = {
      role: 'button',
      tabIndex: '0',
      onKeyPress: function onKeyPress(event) {
        return getIsEnterOrSpace(event) && handleClick(event);
      }
    };
  }
  var Component = as !== null && as !== void 0 ? as : 'button';
  return jsx(Component, _extends({
    ref: ref,
    "aria-disabled": isButtonDisabled,
    "aria-label": label,
    className: className
    ,
    css: styledButton(_objectSpread(_objectSpread({}, propsInternal), {}, {
      disabled: isButtonDisabled
    })),
    "data-testid": dataTestId,
    disabled: isButtonDisabled,
    onClick: handleClick
  }, isToggleButton && {
    'aria-pressed': isToggled
  }, omit(buttonAttributes, propsToOmit), buttonProps, filterAriaAttributes(props)), children || label);
};
var AccessibleButton = React.forwardRef(AccessibleButtonInternal);

export { AccessibleButton };
//# sourceMappingURL=accessible-button.js.map
